import { useState, useEffect, useRef } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { saveAs } from 'file-saver';
import styles from './GenerateInvoice.module.css'

// ------ Components ------ //
import LoadingSpinner from "../../../components/Miscellaneous/LoadingSpinner"
// services
import * as webBridgeService from '../../../services/webBridgeService'
import * as exhibitorLeadCaptureService from '../../../services/exhibitorLeadCaptureService'

const GenerateInvoice = ({ user }) => {
    const navigate = useNavigate()
    const location = useLocation()
    const exhibitorAccount = location.state
    const [loaded, setLoaded] = useState(false);
    const [message, setMessage] = useState("")
    const [messageColor, setMessageColor] = useState('green')
    const [exhibitors, setExhibitors] = useState([]);
    const [pdfName, setPdfName] = useState(null);
    const [email, setEmail] = useState(null)
    const [limitedExhibitors, setLimitedExhibitors] = useState(null)
    const [invoicesFile, setInvoicesFile] = useState([])
    const [processing, setProcessing] = useState(false)
    const [exhibitorLeadCaptureInfo, setExhibitorLeadCaptureInfo] = useState({})
    const exhibitorLeadCaptureInfoRef = useRef(null);
    if (exhibitorLeadCaptureInfoRef === null || exhibitorLeadCaptureInfoRef.current === null) {
        if (!exhibitorAccount || !exhibitorAccount.clientName) {
            exhibitorLeadCaptureInfoRef.current = exhibitorLeadCaptureService.getExhibitorLeadCapture();
        }
        else {
            let passedData = {
                clientId: exhibitorAccount.clientId,
                clientName: exhibitorAccount.clientName,
                leadCaptureId: exhibitorAccount.leadCaptureId,
                leadCaptureName: exhibitorAccount.leadCaptureName,
                exhibitorId: exhibitorAccount.exhibitorId,
            }
            exhibitorLeadCaptureInfoRef.current = passedData
        }
    }

    useEffect(() => {
        const interval = setInterval(() => checkExhibitorLeadCapture(), (300)) // run events fetch every .3 seconds
        return () => clearInterval(interval)
    }, [])
    const checkExhibitorLeadCapture = () => {
        // Update clientevent with every render when its value has changed.
        let savedExhibitorLeadCapture = exhibitorLeadCaptureService.getExhibitorLeadCapture();
        if (exhibitorLeadCaptureInfoRef.current && exhibitorLeadCaptureInfoRef.current.leadCaptureId !== undefined &&
            savedExhibitorLeadCapture && savedExhibitorLeadCapture.leadCaptureId !== undefined && savedExhibitorLeadCapture.exhibitorId !== undefined &&
            (savedExhibitorLeadCapture.leadCaptureId !== exhibitorLeadCaptureInfoRef.current.leadCaptureId ||
                savedExhibitorLeadCapture.exhibitorId !== exhibitorLeadCaptureInfoRef.current.exhibitorId)) {
            setExhibitorLeadCaptureInfo(savedExhibitorLeadCapture)
            exhibitorLeadCaptureInfoRef.current = savedExhibitorLeadCapture;
        }
    }

    const changeDateTimeFormat = dateStr => {
        const parsedDate = Date.parse(dateStr)
        const date = new Date(parsedDate)
        const options = {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
        };
        return date.toLocaleString('en-us', options);
    }
    const fetchExhibitors = async (limitedExhibitors) => {
        //let items = await webBridgeService.fetchLimitedExhibitors(limitedExhibitors);
        let items = await webBridgeService.fetchLimitedFullExhibitors(limitedExhibitors);
        if (items && items.length > 0) {
            setExhibitors(items);
        }
    }
    const isEmailInvalid = () => {
        if (!email) return false; // empty field is valid for local download
        const validEmailRegex = /^[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
        const emailParts = email.split('@');

        if (emailParts.length !== 2) return true;
        const account = emailParts[0];
        const domain = emailParts[1];

        if (account.length > 64) return true;
        else if (domain.length > 255) return true;

        const domainParts = domain.split('.');

        if (domainParts.some((part) => part.length > 63)) return true;

        return !(validEmailRegex.test(email));
    }
    const handleChange = e => {
        setEmail(e.target.value);
    }
    const createRequestBodyEmail = async () => {

        let requestBody = {}
        if (pdfName) {
            requestBody =
            {
                "email": `${email}`,
                "pdfName": `${pdfName}`,
                "limitedExhibitors": `${limitedExhibitors}`,
            }
        }
        else {
            requestBody =
            {
                "email": `${email}`,
                "limitedExhibitors": `${limitedExhibitors}`,
            }
        }
        return await requestBody;
    }
    const createRequestBody = async () => {

        let requestBody = {}
        if (pdfName) {
            requestBody =
            {
                "pdfName": `${pdfName}`,
                "limitedExhibitors": `${limitedExhibitors}`,
            }
        }
        else {
            requestBody =
            {
                "limitedExhibitors": `${limitedExhibitors}`,
            }
        }
       
        return await requestBody;
    }
    const generateInvoiceEmail = async () => {
        const getReqBody = await createRequestBodyEmail()
        try {
            await webBridgeService.emailExhibitorInvoices(getReqBody)
            setMessage('Email sent!')
            setMessageColor('green')
        } catch (err) {
            setMessage('Error: ' + err.message);
            setMessageColor('red')
        }
    }
    const generateInvoicesFile = async () => {
        const getReqBody = await createRequestBody()
        try {
            setMessage('Downloading...')
            setMessageColor('green')
            let invoicesFile = await webBridgeService.generateExhibitorInvoices(getReqBody)
            if (invoicesFile) {
                setInvoicesFile(invoicesFile);
                setMessage('Download Complete!')
                setMessageColor('green')
            }
            return invoicesFile;

        } catch (err) {
            setMessage('Error: ' + err.message);
            setMessageColor('red')
        }
    }
    function base64ToBlob(base64Data, contentType = 'application/pdf') {
        let byteCharacters = '';
        if (base64Data.split(',').length > 1) {
            byteCharacters = atob(base64Data.split(',')[1]);
        }
        else {
            byteCharacters = atob(base64Data);
        }
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += 512) {
            const slice = byteCharacters.slice(offset, offset + 512);
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        return new Blob(byteArrays, { type: contentType });
    }
    const handleJSDownload = async (e) => {
        e.preventDefault();
        if (!limitedExhibitors) {
            return;
        }
        setProcessing(true)
        if (email && !isEmailInvalid()) {
            // send email
            await generateInvoiceEmail();
            setProcessing(false)
            return;
        }
        let holder = null;
        if (invoicesFile || invoicesFile.length < 1) {
            holder = await generateInvoicesFile();
            setProcessing(false)
        }
        if (invoicesFile && invoicesFile.attachment) {
            let buffer = base64ToBlob(invoicesFile.attachmentBase64);
            // Save the Excel file
            saveAs(new Blob([buffer]), `${invoicesFile.fileName}`);
        }
        if (holder && holder.attachment) {
            let buffer = base64ToBlob(holder.attachmentBase64);
            // Save the Excel file
            saveAs(new Blob([buffer]), `${holder.fileName}`);
        }
    };
    useEffect(() => {
        if (limitedExhibitors) {
            fetchExhibitors(limitedExhibitors);
            setLoaded(true);
        }

    }, [limitedExhibitors])
    useEffect(() => {
        if (exhibitorAccount && exhibitorAccount.id !== undefined) {
            // get invoice, create table of items, seperated by 'limitedexhibitors'
            setPdfName(exhibitorAccount.firstName + '_' + exhibitorAccount.lastName + '_' + exhibitorAccount.organization + '.pdf');
            setLimitedExhibitors(exhibitorAccount.id);
        }
        else if (user && user.limitedExhibitors) {
            // have to parse out the exhibitor accounts
            setLimitedExhibitors(user.limitedExhibitors);
        }

    }, [])

    useEffect(() => {
        // get exhibitor
        if ((!exhibitorAccount || !exhibitorAccount.id) && exhibitorLeadCaptureInfo && exhibitorLeadCaptureInfo.exhibitorId) {
            setLimitedExhibitors(exhibitorLeadCaptureInfo.exhibitorId);
        }
    }, [exhibitorLeadCaptureInfo])
    useEffect(() => {
        // check if entry is stored
        // store into local object
        let localExhibitorLeadCapture = exhibitorLeadCaptureService.getExhibitorLeadCapture()
        if (localExhibitorLeadCapture) {
            setExhibitorLeadCaptureInfo(localExhibitorLeadCapture)
        }
        setProcessing(false)
    }, [])


    return (
        <>{!loaded ? <LoadingSpinner /> :
            <>
                <div className={styles.invoiceContainer}>
                    <h1>Invoice View</h1><br />
                    {exhibitorAccount && exhibitorAccount.id?
                        <h2>Mobile App invoice(s) for {exhibitorAccount.firstName} {exhibitorAccount.lastName} - {exhibitorAccount.organization} ({exhibitorAccount.refNumber}).</h2>
                        : <></>}
                    <br /><br />
                    <button id={styles.backButton} onClick={() => navigate(-1)}> Back </button>
                    <br /><br /><br />
                    <>

                        <label> <strong>Enter Email address or leave blank to download invoice(s) locally.</strong> </label>
                        <input
                            type='email'
                            value={email}
                            onChange={handleChange} // option selected
                            name='email'
                            placeholder='Enter Email...'
                        />
                        <br />
                        <button onClick={e => handleJSDownload(e)} disabled={processing} >
                            {email && !isEmailInvalid() ? 'Email Invoices' : 'Download Invoices'}
                        </button>
                        {
                            message ?
                                <h2 style={{ color: messageColor }}>{message}</h2> :
                                <></>
                        }
                        <br />
                        <br />
                        <br />
                        <div>
                            {exhibitors && exhibitors.length > 0 ?
                                exhibitors.map((exhibitorItem, idx) => (
                                    <>
                                        <table className={styles.tablePrintNone} style={{ cellspacing: '0', cellpadding: '3' }}>
                                            <tr className={styles.invoicetr} style={{ border: 'none' }}>
                                                <td className={styles.invoicetd} style={{ width: '10%', align: 'left', valign: 'top', border: 'none' }}>
                                                    Sold to:
                                                </td>
                                                <td className={styles.invoicetd}  style={{ width: '40%', align: 'left', valign: 'top', border: 'none' }}>
                                                    {exhibitorItem.organization} <br />
                                                    {exhibitorItem.firstName} {exhibitorItem.lastName} <br />
                                                    {exhibitorItem.address} <br />
                                                    {exhibitorItem.city}, {exhibitorItem.state ? exhibitorItem.state.stateName : null} {exhibitorItem.postalCode} <br />
                                                    {exhibitorItem.country.countryName}
                                                </td>
                                            </tr>
                                        </table>
                                        <br /> <br />
                                        <table className={styles.tablePrint} style={{ border: '1', cellspacing: '0', cellpadding: '3' }}>
                                            <tr className={styles.invoicetr}>
                                                <th className={styles.invoiceth}>
                                                    Account No.
                                                </th>
                                                <th className={styles.invoiceth}>
                                                    Order No.
                                                </th>
                                                <th className={styles.invoiceth}>
                                                    Invoice Date
                                                </th>
                                            </tr>
                                            <tr className={styles.invoicetr}>
                                                <td className={styles.invoicetd} style={{ width: '10%', align: 'center', valign: 'middle' }}>
                                                    {exhibitorItem.refNumber}
                                                </td>
                                                <td className={styles.invoicetd} style={{ align: 'center', valign: 'middle' }}>
                                                    {exhibitorItem.invoice.invoiceNumber}
                                                </td>
                                                <td className={styles.invoicetd} style={{ align: 'center', valign: 'middle' }}>
                                                    {changeDateTimeFormat(exhibitorItem.createdDate)}
                                                </td>
                                            </tr>
                                        </table>
                                        <table className={styles.tablePrint} style={{ cellspacing: '0', cellpadding: '3', border: '1' }}>
                                            <tr className={styles.invoicetr}>
                                                <th className={styles.invoiceth} style={{ width: '10%' }}>
                                                    Qty
                                                </th>
                                                <th className={styles.invoiceth} style={{ width: '50%' }}>
                                                    Description
                                                </th>
                                                <th className={styles.invoiceth} style={{ width: '20%' }}>
                                                    Unit Price
                                                </th>
                                                <th className={styles.invoiceth} style={{ width: '20%' }}>
                                                    Extended Price
                                                </th>
                                            </tr>
                                            {
                                                exhibitorItem.invoice.productOrders && exhibitorItem.invoice.productOrders.length > 0 ?
                                                    exhibitorItem.invoice.productOrders.map((orderItem, idx) => (
                                                        <>
                                                            {

                                                                (orderItem.cancelled === undefined || orderItem.cancelled === false) && orderItem.quantity && orderItem.quantity > 0 ?
                                                                    <tr className={styles.invoicetr}>
                                                                        <td className={styles.invoicetd} style={{ valign: 'middle', align: 'right' }}>
                                                                            {orderItem.quantity}
                                                                        </td>
                                                                        <td className={styles.invoicetd} style={{ valign: 'middle', align: 'left' }}>
                                                                            {orderItem.productName}
                                                                        </td>
                                                                        <td className={styles.invoicetd} style={{ valign: 'middle', align: 'right' }}>
                                                                            ${orderItem.purchasePrice.toFixed(2)}
                                                                        </td>
                                                                        <td className={styles.invoicetd} style={{ valign: 'middle', align: 'right' }}>
                                                                            ${(orderItem.quantity * orderItem.purchasePrice).toFixed(2)}
                                                                        </td>
                                                                    </tr>
                                                                    : <></>
                                                            }
                                                        </>
                                                    ))
                                                    : <></>
                                            }
                                            <tr>
                                                <td>
                                                    &nbsp;
                                                </td>
                                                <td >
                                                    &nbsp;
                                                </td>
                                                <td >
                                                    &nbsp;
                                                </td>
                                                <td >
                                                    &nbsp;
                                                </td>
                                            </tr>
                                        </table>
                                        <br /><br />
                                        <table className={styles.tablePrint} style={{ cellspacing: '0', cellpadding: '3', border: '1' }}>
                                            <tr className={styles.invoicetr}>
                                                <th className={styles.invoiceth} style={{ width: '16%' }}>
                                                    Subtotal
                                                </th>
                                                <th className={styles.invoiceth} style={{ width: '16%' }}>
                                                    Amount Received
                                                </th>
                                            </tr>
                                            <tr className={styles.invoicetr}>
                                                <td className={styles.invoicetd} style={{ align: 'center', valign: 'middle' }}>
                                                    ${exhibitorItem.invoice.order.orderTotal.toFixed(2)}
                                                </td>
                                                <td className={styles.invoicetd} style={{ align: 'center', valign: 'middle' }}>
                                                    ${exhibitorItem.invoice.order.orderTotal.toFixed(2)}
                                                </td>
                                            </tr>
                                        </table>
                                        <br /><br />
                                        <hr style={{ borderTop: '1px dashed black;' }}></hr>
                                    </>

                                ))

                                : <>No accounts found!</>}

                        </div>
                        <br />

                    </>
                    <br /><br /><br /><br /><br />
                    <button id={styles.backButton} onClick={() => navigate(-1)}> Back </button>
                </div>
            </>
        }
        </>

    );
}

export default GenerateInvoice;